import dataSync from "../../Assets/products/data-synchronisation.jpg";
import migration from "../../Assets/products/migration.jpg";
import dashboard from "../../Assets/products/dashboard.jpg";

export const data = [
  {
    id: 1,
    heading: "SmartSync",
    subheading: "SmartSync as a Realtime Data Synchronization tool",
    paragrapgh:"SmartSync is a premier solution for managing distributed and offline data. With our state-of-the-art technology, you can seamlessly synchronize the distributed and offline data to make it available near to real-time at the centralized database.",
    color:'#E8F0F6',
    image: dataSync,
  },
  {
    id: 2,
    heading: "SmartSync",
    subheading: "SmartSync as a Business data Collation and Reporting Tool",
    paragrapgh: "Experience the power of seamless data collation with SmartSync. With just a few clicks, you can collate business data from multiple sources and generate customised reports and interactive dashboards for in-depth analysis.",
    color:'#E9EBF8',
    image: dashboard,
    },
  {
    id: 3,
    heading: "SmartSync",
    subheading: "SmartSync as a Data Migration Tool",
    paragrapgh: "Introducing SmartSync, the ultimate migration tool for seamless data transition. Whether you are moving to a new system or consolidating data from multiple sources, SmartSync ensures data integrity and accuracy throughout the migration journey.",
    color:'#E5EEF8',
    image: migration,
  },
];